// src/config/index.ts

interface IAppConfig {
	apiEndpoint: string;
	wsEndpoint: string;
	environment: 'development' | 'production';
	isDevelopment: boolean;
	isProduction: boolean;
}

function getEnvironment(): 'development' | 'production' {
	return import.meta.env.NODE_ENV;
}

/**
 * Create the application configuration
 */
function createConfig(): IAppConfig {
	const environment = getEnvironment();

	return {
		apiEndpoint: import.meta.env.VITE_API_ENDPOINT || 'https://localhost.base:4403/v1',
		wsEndpoint: import.meta.env.VITE_WS_ENDPOINT || 'wss://localhost.base:4403',
		environment,
		isDevelopment: environment === 'development',
		isProduction: environment === 'production',
	};
}

// Export the configuration
export const AppConfig = createConfig();

// Export individual values for convenience
export const { apiEndpoint, environment, isDevelopment, isProduction, wsEndpoint } = AppConfig;

// Export default
export default AppConfig;
